/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import { CourierUser, CourierUserFromJSON, CourierUserToJSON } from './CourierUser';
/**
 * 
 * @export
 * @interface Referral
 */
export interface Referral {
    /**
     * 
     * @type {Date}
     * @memberof Referral
     */
    signUpConfirmedOn?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Referral
     */
    emailConfirmedOn?: Date;

    phoneVerifiedOn?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Referral
     */
    firstShipmentConfirmedOn?: Date;
    /**
     * 
     * @type {number}
     * @memberof Referral
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof Referral
     */
    referrerId?: number;
    /**
     * 
     * @type {number}
     * @memberof Referral
     */
    refereeId?: number;
    /**
     * 
     * @type {number}
     * @memberof Referral
     */
    courierId?: number;

    referee?: Partial<CourierUser>;
    referrer?: Partial<CourierUser>;
}

/**
 * Check if a given object implements the Referral interface.
 */
export function instanceOfReferral(value: object): value is Referral {
    return true;
}

export function ReferralFromJSON(json: any): Referral {
    return ReferralFromJSONTyped(json, false);
}

export function ReferralFromJSONTyped(json: any, ignoreDiscriminator: boolean): Referral {
    if (json == null) {
        return json;
    }
    return {
        
        'signUpConfirmedOn': json['signUpConfirmedOn'] == null ? undefined : (new Date(json['signUpConfirmedOn'])),
        'emailConfirmedOn': json['emailConfirmedOn'] == null ? undefined : (new Date(json['emailConfirmedOn'])),
        'phoneVerifiedOn': json['phoneVerifiedOn'] == null ? undefined : (new Date(json['phoneVerifiedOn'])),
        'firstShipmentConfirmedOn': json['firstShipmentConfirmedOn'] == null ? undefined : (new Date(json['firstShipmentConfirmedOn'])),
        'id': json['id'] == null ? undefined : json['id'],
        'referrerId': json['referrerId'] == null ? undefined : json['referrerId'],
        'refereeId': json['refereeId'] == null ? undefined : json['refereeId'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
        'referee': json['referee'] == null ? undefined : CourierUserFromJSON(json['referee']),
        'referrer': json['referrer'] == null ? undefined : CourierUserFromJSON(json['referrer']),
    };
}

export function ReferralToJSON(json: any): Referral {
    return ReferralToJSONTyped(json, false);
}

export function ReferralToJSONTyped(value?: Referral | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'signUpConfirmedOn': value['signUpConfirmedOn'] == null ? undefined : ((value['signUpConfirmedOn']).toISOString()),
        'emailConfirmedOn': value['emailConfirmedOn'] == null ? undefined : ((value['emailConfirmedOn']).toISOString()),
        'phoneVerifiedOn': value['phoneVerifiedOn'] == null ? undefined : ((value['phoneVerifiedOn']).toISOString()),
        'firstShipmentConfirmedOn': value['firstShipmentConfirmedOn'] == null ? undefined : ((value['firstShipmentConfirmedOn']).toISOString()),
        'id': value['id'],
        'referrerId': value['referrerId'],
        'refereeId': value['refereeId'],
        'courierId': value['courierId'],
        'referee': CourierUserToJSON(value['referee']),
        'referrer': CourierUserToJSON(value['referrer']),
    };
}

